var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1281 4457 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8a8a8;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(401 2314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(838.35 2146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(48.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-1",
    d: "M93.483,85.4H55.166c-3.6,0-6.516,2.657-6.516,5.929v50.026c0,3.272,2.92,5.929,6.516,5.929H93.483c3.6,0,6.516-2.657,6.516-5.929V91.329A6.268,6.268,0,0,0,93.483,85.4Zm1.941,55.939a1.877,1.877,0,0,1-1.958,1.782H55.149a1.877,1.877,0,0,1-1.958-1.782V91.329a1.877,1.877,0,0,1,1.958-1.782H93.466a1.877,1.877,0,0,1,1.958,1.782Z",
    transform: "translate(-48.65 -72.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-1",
    d: "M180.283,0H141.966c-3.6,0-6.516,2.657-6.516,5.929a2.289,2.289,0,0,0,4.558,0,1.877,1.877,0,0,1,1.958-1.782h38.317a1.877,1.877,0,0,1,1.958,1.782V55.954a1.877,1.877,0,0,1-1.958,1.782,2.083,2.083,0,1,0,0,4.147c3.6,0,6.516-2.657,6.516-5.929V5.929C186.8,2.657,183.878,0,180.283,0Z",
    transform: "translate(-120.798)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    className: "cls-2",
    width: 80,
    height: 80,
    transform: "translate(880 2143)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.426b064cc605eeab590fa92d4a299653.svg";
export { ForwardRef as ReactComponent };